import {
    useQuery
} from 'react-query';

export default function useGetPrivateMetadata(channel) {
    const landscapeId = RivalIQ.state.landscape.get('id');
    return useQuery(['privateMetadata'], async () => {
        const configuration = await $.getJSON(`/api/landscapes/${landscapeId}/channels/${channel}/privateMetadata`);
        return configuration;
    }, {
        staleTime: Infinity
    });
}
